const PRESETS = [
  { value: "7d", label: "Last 7 days" },
  { value: "30d", label: "Last 30 days" },
  { value: "90d", label: "Last 90 days" },
  { value: "ytd", label: "Year to date" },
  { value: "custom", label: "Custom range" },
];

const ClientAnalyticsDateRange = ({ preset, dateFrom, dateTo, onChange }) => {
  const isCustom = preset === "custom";

  return (
    <div className="client-portal-filters client-analytics-date-range">
      <label className="admin-users-field">
        <span>Date range</span>
        <select
          value={preset}
          onChange={(e) => onChange({ preset: e.target.value })}
        >
          {PRESETS.map((p) => (
            <option key={p.value} value={p.value}>
              {p.label}
            </option>
          ))}
        </select>
      </label>
      {isCustom ? (
        <>
          <label className="admin-users-field">
            <span>From</span>
            <input
              type="date"
              value={dateFrom}
              onChange={(e) => onChange({ dateFrom: e.target.value })}
            />
          </label>
          <label className="admin-users-field">
            <span>To</span>
            <input
              type="date"
              value={dateTo}
              onChange={(e) => onChange({ dateTo: e.target.value })}
            />
          </label>
        </>
      ) : null}
    </div>
  );
};

export default ClientAnalyticsDateRange;
export { PRESETS };
